import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsNumber, IsString, ValidateNested, IsOptional } from "class-validator";

export class GetBankStatementDocument {
  @Expose()
  @IsString()
  contractor!: string; // "Why Not Fly Sp. z o.o."
  @Expose()
  @IsString()
  payer!: string;
  @Expose()
  @IsString()
  currency!: string; // "PLN"
  @Expose()
  @IsOptional()
  @IsString()
  documentNumber!: string; // "2166/09/2021/WM/RZE"
  @Expose()
  @IsNumber()
  exchangeRate!: number; // 0
  @Expose()
  @IsNumber()
  gross!: number; // 452
  @Expose()
  @IsString()
  id!: string; // "9f5f860e-3f13-4ee3-ba90-d9a6de2a98bc"
  @Expose()
  @IsBoolean()
  isSettledWithSelectedBankStatementItem!: boolean; // false
  @Expose()
  @IsNumber()
  leftToPay!: number; // 452
  @Expose()
  @IsNumber()
  settled!: number; // 0
  @Expose()
  @IsNumber()
  settledWithSelectedBankStatementItemCount!: number; // 0
}

export class GetBankStatementDocumentsResponse extends GenericTableResponse<GetBankStatementDocument> {
  @Type(() => GetBankStatementDocument)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<GetBankStatementDocument>;
}
